console.log("Outbound Link Script Loaded!");

const trackedDomains = [
    "buywake.com",
    "sunandski.com",
    "wakehouse.com",
    "overtons.com",
    "evo.com",
    "onewake.com",
    "perfski.com",
    "activewake.com",
    "barts.com",
    "wakeboards.com",
    "backcountry.com",
    "wakemakers.com",
    "wakesports.com",
    "boardco.com",
    "miamiskinautiques.com",
    "marine-products.com",
    "the-house.com",
    "campingworld.com",
    "scuba.com",
    "bakesonline.com",
    "pullproshop.com",
];

function isExternalLink(link) {
    try {
        const url = new URL(link.href);
        return url.hostname !== window.location.hostname;
    } catch (e) {
        return false; 
    }
}

function isTrackedDomain(href) {
    return trackedDomains.some((domain) => href.includes(domain));
}

function trackOutboundLink(event) {
    const link = event.target.closest("a");
    if (!link) return;

    const destinationURL = link.href;
    const linkText = link.textContent || link.innerText || "";
    const pageURL = window.location.href;

    if (isTrackedDomain(destinationURL)) {
        event.preventDefault();

        Shopify.analytics.publish("outbound_link_clicked", {
            destination_url: destinationURL,
            link_text: linkText.trim(),
            page_url: pageURL,
        });

        console.log("Tracked Outbound Link Clicked:", {
            destination_url: destinationURL,
            link_text: linkText,
            page_url: pageURL,
        });

        window.open(destinationURL, "_blank");
    } else {
        console.log("Untracked External Link Clicked:", destinationURL);
    }
}

function shouldSkipLink(link) {
    return (
        link.classList &&
        link.classList.contains("header__link") &&
        link.classList.contains("action-area__link") &&
        link.hasAttribute("data-show-search-trigger")
    );
}

function attachIfExternal(link) {
    if (shouldSkipLink(link)) {
        console.log("Skipped link:", link.href);
        return;
    }
    if (isExternalLink(link)) {
        link.addEventListener("click", trackOutboundLink);
    }
}

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("a").forEach(attachIfExternal);
});

const LinkObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            if (node.nodeType !== 1) return;

            if (node.tagName === "A") {
                attachIfExternal(node);
            } else {
                node.querySelectorAll("a").forEach(attachIfExternal);
            }
        });
    });
});

LinkObserver.observe(document.body, { childList: true, subtree: true });